// services/api.js
import axios from 'axios';

// Create an Axios instance with our API base URL
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://csmbe.depedroxi.ph/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});


// Add a request interceptor to include the auth token on every request
api.interceptors.request.use(
  config => {
    // Get the token from localStorage
    const token = localStorage.getItem('token');
    
    // Debug log
    console.log('Request interceptor - Token:', token ? 'Present' : 'Missing');
    
    // If token exists, add it to the authorization header
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Try to get the CSRF token at request time
    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    if (csrfToken) {
      config.headers['X-CSRF-TOKEN'] = csrfToken.getAttribute('content');
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.log('401 Unauthorized - Clearing token and redirecting to login');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;